/*
 * HomeConstants
 * Each action has a corresponding type, which the reducer knows and picks up on.
 * To avoid weird typos between the reducer and the actions, we save them as
 * constants here. We prefix them with 'yourproject/YourComponent' so we avoid
 * reducers accidentally picking up actions they shouldn't.
 *
 * Follow this format:
 * export const YOUR_ACTION_CONSTANT = 'yourproject/YourContainer/YOUR_ACTION_CONSTANT';
 */



export const ON_NOTIFY = 'boilerplate/FailedInvoice/ON_NOTIFY'
export const LOADER_STATUS = 'boilerplate/Reports/LOADER_STATUS'
export const CHART_INFO = 'biolerplat/Reports/CHART_INFO'
export const RESET_CHART_INFO = 'biolerplate/Reports/RESET_CHART_INFO'
export const LINE_INFO = 'biolerplat/Reports/LINE_INFO'
export const RESET_LINE_INFO = 'biolerplate/Reports/RESET_LINE_INFO'
